/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Delete_Button_TitleInputs */

const en_event_delete_button_title = /** @type {(inputs: Event_Delete_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Event`)
};

const fr_event_delete_button_title = /** @type {(inputs: Event_Delete_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer l'evenement`)
};

const de_event_delete_button_title = /** @type {(inputs: Event_Delete_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis entfernen`)
};

const it_event_delete_button_title = /** @type {(inputs: Event_Delete_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi evento`)
};

const ru_event_delete_button_title = /** @type {(inputs: Event_Delete_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить событие`)
};

const es_event_delete_button_title = /** @type {(inputs: Event_Delete_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar evento`)
};

const zh_cn2_event_delete_button_title = /** @type {(inputs: Event_Delete_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除事件`)
};

const ja_event_delete_button_title = /** @type {(inputs: Event_Delete_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを削除`)
};

const hi_event_delete_button_title = /** @type {(inputs: Event_Delete_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट हटाएं`)
};

const pt_pt2_event_delete_button_title = /** @type {(inputs: Event_Delete_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover evento`)
};

/**
* | output |
* | --- |
* | "Remove Event" |
*
* @param {Event_Delete_Button_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_delete_button_title = /** @type {((inputs?: Event_Delete_Button_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Delete_Button_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_delete_button_title(inputs)
	if (locale === "de") return de_event_delete_button_title(inputs)
	if (locale === "it") return it_event_delete_button_title(inputs)
	if (locale === "ru") return ru_event_delete_button_title(inputs)
	if (locale === "es") return es_event_delete_button_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_delete_button_title(inputs)
	if (locale === "ja") return ja_event_delete_button_title(inputs)
	if (locale === "hi") return hi_event_delete_button_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_delete_button_title(inputs)
	return en_event_delete_button_title(inputs)
});